// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1gi1h","FooterContainer":"Footer_FooterContainer__3igse","Logo":"Footer_Logo__FgmBX","SocialIcons":"Footer_SocialIcons__2D1zj"};